<template>
  <div class="container">
    <h3>Các Nhu cầu cơ bản</h3>
    <b-button v-b-toggle.collapse-1 variant="primary" @click="mode = 'insert'"
      >Thêm mới</b-button
    >
    <b-collapse id="collapse-1" class="mt-2">
      <b-card>
        <template v-for="input in forms">
          <div
            :class="'col-md-' + (input.colspan ? input.colspan : 6)"
            v-if="input.type == 'line'"
            v-bind:key="input.col"
          >
            <hr />
          </div>

          <div
            :class="'col-md-' + (input.colspan ? input.colspan : 6)"
            v-if="input.type == 'label'"
            v-bind:key="input.col"
          >
            <h2>{{ input.defaultValue }}</h2>
          </div>
          <b-form-group
            :class="'col-md-' + (input.colspan ? input.colspan : 6)"
            v-bind:key="'f' + input.col"
            v-if="input.visible && isFormControl(input)"
            :set="(field = columns[input.col])"
          >
            <label class="input-header"
              >{{ field.alias }}
              <span v-if="input.required" class="text-red">*</span>
            </label>

            <div v-if="input.type == 'date'">
              <b-form-input
                type="date"
                v-model="input.value"
                :placeholder="field.alias"
                :disabled="input.disabled"
              />
            </div>

            <div v-if="input.type == 'multi-select'">
              <multiselect
                v-model="input.value"
                :searchable="false"
                :close-on-select="false"
                :multiple="true"
                :options="field.options"
                :placeholder="field.alias"
              >
              </multiselect>
            </div>

            <div v-if="input.type == 'text'">
              <b-form-input
                type="text"
                v-model="input.value"
                :placeholder="field.alias"
                :disabled="input.disabled"
              />
            </div>
          </b-form-group>
        </template>

        <b-button v-if="!isLoading" variant="primary" @click="submitNeed"
          >Lưu</b-button
        >

        <b-button v-if="!isLoading" v-b-toggle.collapse-1 class="ml-2"
          >Đóng</b-button
        >

        <div class="col-md-12" v-if="isLoading">
          Loading...
        </div>
      </b-card>
    </b-collapse>
    <hr />

    <b-spinner v-if="isLoadingList"></b-spinner>
    <div v-if="!isLoadingList">
      <b-table
        striped
        sticky-header
        head-variant="light"
        :items="needs"
        :fields="fields"
        sort-icon-left
        responsive="sm"
      >
        <template #cell(created_at)="data">
          {{ formatDate(data.item.created_at) }}
        </template>

        <template #cell(actions)="data">
          <b-button
            variant="success"
            size="sm"
            v-b-toggle.collapse-1
            @click="edit(data.item)"
            >Sửa</b-button
          >
          <b-button
            variant="danger"
            size="sm"
            @click="remove(data.item.id)"
            >Xoá</b-button
          >
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import NeedsMeta from "@/module-needs/NeedsMeta";
import NeedsService from "@/module-needs/NeedsService";
import Multiselect from "vue-multiselect";

import moment from "moment";

export default {
  name: "ClientNeedsList",
  components: { Multiselect },
  computed() {},
  data() {
    return {
      needs: [],
      fields: [...NeedsMeta.fields, "actions"],
      isLoadingList: false,
      needsService: null,
      mode: "insert",
      forms: NeedsMeta.input_view.forms,
      columns: NeedsMeta.columns,
      isLoading: false,
      curNeedId: null,
    };
  },

  methods: {
    isFormControl(input) {
      return input.type != "line" && input.type != "label";
    },

    clientLabel(s) {
      return s.fullname + "-" + s.phone;
    },

    formatDateTime(v) {
      return moment(v).format("DD/MM/YYYY hh:mm:ss");
    },

    formatDate(v) {
      return moment(v).format("DD/MM/YYYY");
    },

    viewClient(id) {
      let routeData = this.$router.resolve({
        path: `/v2/clients/${id}/view`,
        query: {},
      });
      window.open(routeData.href, "_blank");
    },

    getValueFromField(field) {
      if (field.value) {
        if (field.value instanceof Array) {
          return "'" + field.value.join(",") + "'";
        } else if (field.value instanceof String) {
          return "'" + field.value + "'";
        } else {
          if (
            field.type === "text" ||
            field.type === "link" ||
            field.type === "select" ||
            field.type === "multi-select" ||
            field.type === "textarea" ||
            field.type === "typeahead" ||
            field.type === "image"
          ) {
            return "'" + field.value + "'";
          } else if (field.type === "date") {
            return (
              "'" + moment(field.value).format("yyyy-MM-DD HH:mm:ss") + "'"
            );
          } else {
            return field.value;
          }
        }
      }

      return null;
    },

    edit(data) {
      this.mode = "update";
      this.curNeedId = data.id;
  
      for (const [key, value] of Object.entries(data)) {
        for (var i in this.forms) {
          if (this.forms[i].col == key) {
            if (key == "created_at")
              this.forms[i].value = value.substring(0, 10);
            else if (this.forms[i].type == 'multi-select' && value)
              this.forms[i].value = value.split(',');
            else this.forms[i].value = value;
          }
        }
      }
    },

    async remove(id) {
      this.isLoadingList = true;
      await this.needsService.remove(id);
      await this.loadNeedList();
      this.isLoadingList = false;
    },

    async loadNeedList() {
      this.isLoadingList = true;
      var needs = await this.needsService.listAllByClient(this.clientId);
      this.needs = needs;

      this.isLoadingList = false;
    },

    async submitNeed() {
      this.isLoading = true;

      var _columns = [];
      var _values = [];

      _columns.push("client_id");
      _values.push(this.clientId);

      for (var i in this.forms) {
        var f = this.forms[i];
        if (f.value) {
          _columns.push(f.col);
          _values.push(this.getValueFromField(f));
        }
      }

      if (this.mode == "insert")
        await this.needsService.submitNeed(_columns, _values);
      else
        await this.needsService.updateNeed(this.curNeedId, _columns, _values);

      const checkCols = [..._columns];
      const allColumns = NeedsMeta.list_views.columns;

      for (let i = 0; i < allColumns.length; i++) {
        if (!checkCols.includes(allColumns[i])) {
          _columns.push(allColumns[i]);
          _values.push("null");
        }
      }

      await this.needsService.updateNeedOnClientTable(
        this.clientId,
        _columns,
        _values
      );

      await this.loadNeedList();

      this.isLoading = false;
    },
  },
  props: ["clientId"],
  mounted() {
    this.needsService = new NeedsService();
    this.loadNeedList();
  },
};
</script>

<style scoped>
.form-group {
  display: inline-block !important;
}
</style>
